var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'graduation-cap']}}),_vm._v("\n  SIPlanWeb\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }